<template>
  <div>
    <div v-if="initialized === false">Not found modelName: {{ modelName }}</div>
    <div
      :key="$core.$router.currentRoute.fullPath"
      v-if="initialized"
    >
      <ModelIndexDirectus
        :key="$core.$router.currentRoute.fullPath"
        v-bind="modelIndexComponentProps"
        ref="modelIndexDirectusRef"
      >
        <template #header>
          <router-link
            v-if="virtualModelCreatable && model.creatable !== false"
            class="btn btn-primary ml-2 component-model-index-page--add-new-button"
            :to="{ name: `fallback_model-new`, ...routerLinkOption }"
          >
            <ficon type="plus"></ficon>
            新規追加
          </router-link>
        </template>
      </ModelIndexDirectus>
    </div>
  </div>
</template>

<script lang="ts">
import { ModelFactory } from '../../../common/$models'
// import { convertURLQueryFilterForModelIndex } from '../../ModelIndex/$modeIndexSearchService'

export const convertURLQueryFilterForModelIndex = (queryFilters: string) => {
  if (!queryFilters) {
    return null
  }
  if (typeof queryFilters === 'string') {
    try {
      const parsed = JSON.parse(decodeURIComponent(queryFilters))
      return Object.keys(parsed).reduce((res, key) => {
        if (typeof parsed[key] === 'string' || typeof parsed[key] === 'number') {
          res[key] = { _eq: parsed[key] }
        } else {
          res[key] = parsed[key]
        }
        return res
      }, {})
    } catch (e) {
      console.error('[convertURLQueryFilterForModelIndex] Failed to parse url queryFilters:', e)
      return null
    }
  }
}

export default {
  props: {
    passedVirtualModelName: {},
  },
  data() {
    return {
      initialized: null,
    }
  },
  computed: {
    modelName() {
      return this.$route.params.fallback_model
    },
    model(): ModelFactory {
      return $core.$models[this.modelName]
    },
    virtualModelName() {
      return this.$route.query.virtualModel || this.passedVirtualModelName
    },
    virtualModel() {
      return $core.$virtualModels[this.virtualModelName] || null
    },
    virtualModelColumns() {
      return this.virtualModel ? this.virtualModel.colNames : null
    },
    virtualModelCreatable() {
      return this.virtualModel?.creatable !== false
    },
    routerLinkOption() {
      return {
        params: { fallback_model: this.modelName },
        query: this.virtualModelName ? { virtualModel: this.virtualModelName } : {},
      }
    },
    searchConditionSaveKey() {
      return (
        this.virtualModel
          ? this.virtualModel.enableSearchConditionSave
          : this.model.enableSearchConditionSave
      )
        ? this.$route.fullPath
        : null
    },
    modelIndexComponentProps() {
      const bindProps = {
        modelName: this.modelName,
        virtualModelName: this.virtualModelName,
        headerTitle: this.headerTitle,
        fields: this.virtualModelColumns,
        bulkControllable: this.virtualModel
          ? this.virtualModel.bulkControllable
          : this.model.bulkControllable,
        searchConditionSaveKey: this.searchConditionSaveKey,
        urlQueryFilterChangeable: !!this.$route.query.urlQueryFilterChangeable,
        queryFilters: this.queryFilters,
        initialPage: Number(this.$route.query.page) || 1,
      }
      return bindProps
    },
    headerTitle() {
      return (
        this.$route.query?.headerTitle ||
        `${(this.virtualModel || this.model)?.tableLabel || this.modelName}`
      )
    },
    queryFilters() {
      return convertURLQueryFilterForModelIndex(
        this.$route.query.filters || this.$route.query.filter,
      )
    },
  },
  created() {
    this.$nextTick(async () => {
      this.initialized = !!this.model
    })
  },
  beforeUnmount() {
    this.$refs.modelIndexDirectusRef = null
  },
}
</script>
